import request from '@/utils/request'

/**
 * 桥梁预警规则接口（问题列表3 - #9）
 * 与后端 BridgeAlertRuleController 对应（/bridge-alert-rule）
 * 规则内容 content 为 JSON 字符串（category/level/rule/detectionMethod/systemAction/manualAction）
 * 某桥首次查询无规则时，后端会自动写入缺省默认规则。
 */

/**
 * 获取某桥的预警规则列表（分页）
 * @param {Object} params 查询参数
 * @param {number} params.bridgeId 桥梁ID（必填）
 * @param {number} [params.pageNum=1] 页码
 * @param {number} [params.pageSize=10] 每页条数
 * @returns {Promise<{code:number, message:string, data:{list:Array, total:number, pageNum:number, pageSize:number, pages:number}}>}
 */
export function getAlertRules(params) {
  return request({
    url: '/bridge-alert-rule/list',
    method: 'get',
    params
  })
}

/**
 * 根据ID获取预警规则详情
 * @param {number} id 规则ID
 */
export function getAlertRuleById(id) {
  return request({
    url: `/bridge-alert-rule/${id}`,
    method: 'get'
  })
}

/**
 * 新增预警规则
 * @param {Object} data 规则数据
 * @param {number} data.bridgeId 桥梁ID
 * @param {string} data.ruleName 规则名称
 * @param {string} data.content 规则内容（JSON字符串）
 */
export function createAlertRule(data) {
  return request({
    url: '/bridge-alert-rule',
    method: 'post',
    data
  })
}

/**
 * 更新预警规则
 * @param {number} id 规则ID
 * @param {Object} data 规则数据（ruleName/content）
 */
export function updateAlertRule(id, data) {
  return request({
    url: `/bridge-alert-rule/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除预警规则
 * @param {number} id 规则ID
 */
export function deleteAlertRule(id) {
  return request({
    url: `/bridge-alert-rule/${id}`,
    method: 'delete'
  })
}

export default {
  getAlertRules,
  getAlertRuleById,
  createAlertRule,
  updateAlertRule,
  deleteAlertRule
}
